import React, {useContext, useState, useEffect} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Toolbar from '@material-ui/core/Toolbar'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import ReplayIcon from '@material-ui/icons/Replay'
import Typography from '@material-ui/core/Typography'
import dayjs from 'dayjs'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import _firebaseContext from '../../contexts/firebaseContext'

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
})

function TableToolbar() {
    const firebaseContext = useContext(_firebaseContext)

    const handleReload = async (event) => {
        firebaseContext.changeData.setFetchingState({
            ...firebaseContext.data.fetchingState,
            tracks: true
        });
        await firebaseContext.updateCache();
        await firebaseContext.getAllTracks();

        /**
         * Обратить внимание, что в скрипте миграция выполняется через .add
         */
        // await firebaseContext.tracksMigration();
    }

    return (
        <Toolbar>
            <Tooltip title="Обновить кэш">
                <IconButton aria-label="reload list" onClick={handleReload}>
                    <ReplayIcon/>
                </IconButton>
            </Tooltip>
        </Toolbar>
    )
}

export default function TracksTable() {
    const classes = useStyles()
    const firebaseContext = useContext(_firebaseContext)
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            await firebaseContext.getAllTracks()
        })();
    }, [])

    useEffect(() => {
        setIsLoading(firebaseContext.data.fetchingState.tracks);
    }, [firebaseContext.data.fetchingState.tracks]);

    const tracks = firebaseContext.data.tracks
    return (
        <>
            <TableContainer component={Paper}>
                <TableToolbar/>
                <Table
                    className={classes.table}
                    aria-label="simple table"
                    size="small"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell>Название трека</TableCell>
                            <TableCell align="right">Дневной трек</TableCell>
                            <TableCell align="right">Ночной трек</TableCell>
                            <TableCell align="right">Статус</TableCell>
                            <TableCell align="right">Планета</TableCell>
                            {/* <TableCell align="right">
                                Ссылка
                            </TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(tracks) &&
                        tracks.map((track) => (
                            <TableRow key={track.id}>
                                <TableCell component="th" scope="track">
                                    {track.name}
                                </TableCell>
                                <TableCell align="right">
                                    <Typography>{track.description}</Typography>
                                    <Typography>
                                        {(track.trackTimespan &&
                                            dayjs
                                                .unix(track.trackTimespan)
                                                .utc()
                                                .format(
                                                    'H [ч.] m [мин.] s [сек.]'
                                                )) ||
                                        '-'}
                                    </Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <Typography>
                                        {track.nightDescription}
                                    </Typography>
                                    <Typography>
                                        {(track.nighttrackTimespan &&
                                            dayjs
                                                .unix(track.nighttrackTimespan)
                                                .utc()
                                                .format(
                                                    'H [ч.] m [мин.] s [сек.]'
                                                )) ||
                                        '-'}
                                    </Typography>
                                </TableCell>
                                <TableCell align="right">
                                    {track.trackStatus}
                                </TableCell>
                                <TableCell align="right">
                                    {track.planet?.name || ''}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {
                isLoading &&
                <Backdrop style={{zIndex: 10000}} open={true}>
                    <CircularProgress style={{color: '#FFF'}}/>
                </Backdrop>
            }
        </>
    )
}
